import React, { useEffect, useMemo } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import "./ticketReceipt.css"



function TicketStatusToUsedResultModal({
  showModalTicketStatusToUsedResult,
  setShowModalTicketStatusToUsedResult,
  updatedTicket,
  setTickets,
  onResetAndFocus,
  fetchAllTickets,
}) {
  const handleClose = () => {
    setShowModalTicketStatusToUsedResult(false);
    setTickets(null);
    onResetAndFocus();
    fetchAllTickets();
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && showModalTicketStatusToUsedResult) {
        event.preventDefault();
        event.stopPropagation();
        handleClose();

        // navigate("/TicketSearch");
      }
    };

    // اضافه کردن لیسنر کیبورد هنگام نمایش مدال
    if (showModalTicketStatusToUsedResult) {
      document.addEventListener("keydown", handleKeyDown);
    }

    // حذف لیسنر کیبورد هنگام بستن مدال یا عدم نمایش
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModalTicketStatusToUsedResult]);

  /********************************************* */
  const receiptData = useMemo(() => {
    // داده‌های نمونه با فرمت مناسب برای پرینتر فروشگاهی
    const showReserveItemGroupTitleInTicketPlan =
      updatedTicket.showReserveItemGroupTitleInTicketPlan;
    const showReserveItemTitleInTicketPlan =
      updatedTicket.showReserveItemTitleInTicketPlan;
    const ticketPlanDetail =
      updatedTicket.ticketPlanDetail;
    const textTitleGroupTicket = [
      showReserveItemGroupTitleInTicketPlan &&
      updatedTicket.amusementServiceReserveItemGroupTitle,
      showReserveItemTitleInTicketPlan &&
      updatedTicket.amusementServiceReserveItemTitle,
      ticketPlanDetail && updatedTicket.ticketPlanDetail,
    ].filter(Boolean);

    const mockData = {
      parkName: updatedTicket.isEvent ? updatedTicket.hallEventTitle + " - " + updatedTicket.hallName : updatedTicket.amusementServiceName,
      date: updatedTicket.isEvent ? updatedTicket.checkInDate + " - " + updatedTicket.executionTime : updatedTicket.checkInDate,
      customerName: updatedTicket.userName,
      session: textTitleGroupTicket,
    };
    return mockData
  }, [updatedTicket]);

  const generateReceiptText = () => {
    if (!receiptData) return "";

    const lineLength = 48; // عرض معمول پرینترهای فروشگاهی
    const separator = "-".repeat(lineLength);
    let receiptText = ""
    updatedTicket?.invalidTicketCount.forEach(item => {
      receiptText += `
      ${receiptData.parkName}
      ${receiptData.date}
      ${receiptData.customerName}
      ${receiptData.session}
      ${item}
      ${separator}\n‍‍`
    })

    return receiptText;
  };

  // تابع کمکی برای居中 کردن متن
  String.prototype.center = function (width) {
    const pad = Math.max(0, width - this.length);
    return (
      " ".repeat(Math.floor(pad / 2)) + this + " ".repeat(Math.ceil(pad / 2))
    );
  };

  const handlePrint = async () => {
    if (!receiptData) return;

    const receiptText = generateReceiptText();

    // استفاده از WebUSB برای پرینترهای مدرن یا ارسال به API
    try {
      // روش ۱: چاپ از طریق API (پیشنهادی)
      // await fetch("/print-api", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ text: receiptText }),
      // });

      // روش ۲: چاپ مستقیم (نیاز به پیکربندی سرور)
      window.print()

    } catch (error) {
      alert("خطا در ارسال به پرینتر!");
    }
  };

  return (
    <Modal
      centered
      onHide={handleClose}
      show={showModalTicketStatusToUsedResult}
    >
      <Modal.Header className="bg-white border-0"></Modal.Header>
      <Modal.Body className=" pt-0 rounded-4 mt-0 acc">
        <div className="text-center">
          <span className="large-svg text-green">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="9" />
                <path d="m8 12l3 3l5-6" />
              </g>
            </svg>
          </span>
        </div>
        <h3 className="text-green text-center mt-3 mb-5">
          ابطال با موفقیت انجام شد.
        </h3>
        <Card className="rounded-4 border-secondary mb-3">
          <Card.Body className="px-3 py-4">
            <div className="d-flex justify-content-between ">
              <div className="d-flex">
                <span className="small-svg mr-1">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </g>
                  </svg>
                </span>
                <span>{updatedTicket?.userName} </span>
              </div>
              <div className="d-flex">
                <span>{updatedTicket?.userMobile}</span>
                <span className="small-svg mr-1">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                    <path
                      fill="currentColor"
                      d="M11.5 0h-7C3.675 0 3 .675 3 1.5v13c0 .825.675 1.5 1.5 1.5h7c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5M6 .75h4v.5H6zM8 15a1 1 0 1 1 0-2a1 1 0 0 1 0 2m4-3H4V2h8z"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div>
              <Row className="my-5">
                <Col>
                  <div className="d-flex text-red align-items-center">
                    <span className="small-svg mr-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 256 256"
                      >
                        <path
                          fill="currentColor"
                          d="M216 44H40a12 12 0 0 0-12 12v160a4 4 0 0 0 5.79 3.58L64 204.47l30.21 15.11a4 4 0 0 0 3.58 0L128 204.47l30.21 15.11a4 4 0 0 0 3.58 0L192 204.47l30.21 15.11a4.05 4.05 0 0 0 1.79.42a4 4 0 0 0 4-4V56a12 12 0 0 0-12-12m4 165.53l-26.21-13.11a4 4 0 0 0-3.58 0L160 211.53l-30.21-15.11a4 4 0 0 0-3.58 0L96 211.53l-30.21-15.11a4 4 0 0 0-3.58 0L36 209.53V56a4 4 0 0 1 4-4h176a4 4 0 0 1 4 4ZM196 112a4 4 0 0 1-4 4h-48a4 4 0 0 1 0-8h48a4 4 0 0 1 4 4m0 32a4 4 0 0 1-4 4h-48a4 4 0 0 1 0-8h48a4 4 0 0 1 4 4m-84-52H64a4 4 0 0 0-4 4v64a4 4 0 0 0 4 4h48a4 4 0 0 0 4-4V96a4 4 0 0 0-4-4m-4 64H68v-56h40Z"
                        />
                      </svg>
                    </span>
                    <span> استفاده شده </span>
                    <span className="d-inline-block bg-red rounded-2 px-3 py-1 ml-1">
                      {updatedTicket?.invalidTicketCount.length}
                    </span>
                  </div>
                </Col>
                <Col className="text-right ">
                  <div className="d-flex justify-content-end text-green align-items-center">
                    <span className="small-svg mr-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M3 10h-.75c0 .414.336.75.75.75zm0 4v-.75a.75.75 0 0 0-.75.75zm18-4v.75a.75.75 0 0 0 .75-.75zm0 4h.75a.75.75 0 0 0-.75-.75zM5 5.75h5v-1.5H5zm5 0h9v-1.5h-9zm9 12.5h-9v1.5h9zm-9 0H5v1.5h5zM9.25 5v14h1.5V5zm-5.366 6.116a1.25 1.25 0 0 1 0 1.768l1.06 1.06a2.75 2.75 0 0 0 0-3.889zm16.232 1.768a1.25 1.25 0 0 1 0-1.768l-1.06-1.06a2.75 2.75 0 0 0 0 3.889zM3 10.75c.321 0 .64.122.884.366l1.06-1.06A2.74 2.74 0 0 0 3 9.25zm.75-.75V7h-1.5v3zm0 7v-3h-1.5v3zm.134-4.116A1.24 1.24 0 0 1 3 13.25v1.5c.703 0 1.408-.269 1.945-.806zm16.232-1.768c.244-.244.563-.366.884-.366v-1.5c-.703 0-1.408.269-1.945.806zM20.25 7v3h1.5V7zm0 7v3h1.5v-3zm.75-.75c-.321 0-.64-.122-.884-.366l-1.06 1.06A2.74 2.74 0 0 0 21 14.75zm-16 5c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 5 19.75zm14 1.5A2.75 2.75 0 0 0 21.75 17h-1.5c0 .69-.56 1.25-1.25 1.25zm0-14c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 19 4.25zM5 4.25A2.75 2.75 0 0 0 2.25 7h1.5c0-.69.56-1.25 1.25-1.25z"
                        />
                      </svg>
                    </span>
                    <span>کل بلیط ها </span>

                    <span className="d-inline-block bg-green rounded-2 px-3 py-1 ml-1">
                      {updatedTicket?.ticketCount}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="mb-4 border-top pt-3 text-dark-primary">
              شماره بلیط های ابطال شده
            </div>
            <div className="d-flex text-dark-primary flex-wrap">
              {updatedTicket?.invalidTicketCount?.map((item) => (
                <div key={item} className="mr-4">{item}</div>
              ))}
            </div>
            {updatedTicket?.cancelledTicketCount > 0 && (
              <div className="mt-4 bg-red text-red px-3 py-3 rounded-3">
                <span className="text-red small-svg mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M13 7.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-3 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.25h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75V12h-.75a.75.75 0 0 1-.75-.75"
                    />
                    <path
                      fill="currentColor"
                      d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1M2.5 12a9.5 9.5 0 0 0 9.5 9.5a9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5A9.5 9.5 0 0 0 2.5 12"
                    />
                  </svg>
                </span>
                بلیط به شماره {updatedTicket?.cancelledTicketCount.join(", ")}{" "}
                کنسل شده است
              </div>
            )}
          </Card.Body>
        </Card>
        <Button variant="secondary" onClick={handleClose} className="py-2 px-4">
          متوجه شدم
        </Button>
        <Button
          variant="primary"
          onClick={handlePrint}
          className="py-2 px-4 my-3 me-2"
        >
          چاپ بلیط{" "}
        </Button>

        <div className="receipt-wrapper"
          style={{
            textAlign: "center"
          }}>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              direction: "rtl",
              textAlign: "center",
              border: "1px solid #ddd",
              padding: "10px",
              margin: "0 auto",
              maxHeight: window.innerWidth < 768 ? "259px" : "386px",
              overflowY: "auto",
              fontSize: "14px",
              lineHeight: "1.3",
              background: "#f9f9f9",
            }}
          >
            {receiptData ? updatedTicket.isEvent ?
              updatedTicket?.hallEventSeats?.map((item, index) => (
                <div key={index} className="w-100">
                  <div>{receiptData.parkName}</div>
                  <div className="receipt-date">جایگاه {item.hallBlockName} - ردیف {item.hallRowName} - صندلی {item.hallSeatName}</div>
                  {receiptData.session.map((html, indexxx) => (
                    <span key={indexxx}>
                      <span
                        id="des"
                        dangerouslySetInnerHTML={{
                          __html: html,
                        }}
                      />
                      {indexxx < receiptData.session.length - 1 && " - "}
                    </span>
                  ))}
                  <div className="receipt-date">{receiptData.date}</div>
                  <div>
                    شماره بلیط : {item.id}
                  </div>
                  <div>{receiptData.customerName}</div>
                  <div>تفریحان</div>
                  {index < updatedTicket?.hallEventSeats.length - 1 && <div>{"-".repeat(30)}</div>}
                </div>
              ))
              : updatedTicket?.invalidTicketCount?.map((item, index) => (
                <div key={index} className="w-100">
                  <div>{receiptData.parkName}</div>
                  {receiptData.session.map((html, indexxx) => (
                    <span key={indexxx}>
                      <span
                        id="des"
                        dangerouslySetInnerHTML={{
                          __html: html,
                        }}
                      />
                      {indexxx < receiptData.session.length - 2 && " - "}
                    </span>
                  ))}
                  <div className="receipt-date">{receiptData.date}</div>
                  <div>
                    شماره بلیط : {item}
                  </div>
                  <div>{receiptData.customerName}</div>
                  <div>تفریحان</div>
                  {index < updatedTicket?.invalidTicketCount.length - 1 && <div>{"-".repeat(30)}</div>}
                </div>
              )) : "در حال بارگذاری..."}
          </pre>
        </div>
      </Modal.Body>
    </Modal>
  );
}
export default TicketStatusToUsedResultModal;
